module.exports = __webpack_public_path__ + "static/media/julek-janski.dbd274f1.png";